import { useIsCategoryAvailable } from 'src/modules/checkout/composables/sales-availability/categories/IsCategoryAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate category availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  order: null
})

// categories and options are optional, assuming the caller may intend to use computeAvailableCategories directly
export function useAvailableCategories (categories = [], options = DEFAULT_OPTIONS) {
  const { isCategoryAvailable } = useIsCategoryAvailable()

  function computeAvailableCategories (categories, { salesChannel, order } = DEFAULT_OPTIONS) {
    return _(toValue(categories))
      .filter(category => isCategoryAvailable(category, { salesChannel, order }))
      .sortBy('displayOrder')
      .value()
  }

  // We wrap categories with computed to ensure reactivity
  // useAvailableCategories may be called with a null model, which wouldn't be reactive
  // e.g. configuration?.categories?.data before configuration is set
  // This would prevent availableCategories from reacting to changes in categories
  // If categories is set or already reactive, this is a safe no-op
  // This ensures useAvailableCategories is resilient without complicated usage requirements
  const availableCategories = computed(() => computeAvailableCategories(computed(() => categories), options))

  return {
    computeAvailableCategories,
    availableCategories
  }
}
